import { t } from "i18next";
import moment from "moment";

import { LIFETIME_SERIES } from "../ProductLifetimeChart/constants";
import { ProductStatsByBarcodeTableProps } from "./ProductStatsByBarcodeTable.types";

import styles from "./ProductStatsByBarcodeTable.module.scss";

const ProductStatsByBarcodeTable = ({
  point,
  breakdownBy
}: ProductStatsByBarcodeTableProps) => {
  if (!point || point.byBarcode.length === 0) {
    return (
      <div className={styles.byBarcode_empty}>
        {t("Select a point on the graph to see the variant breakdown")}
      </div>
    );
  }

  const titleFormat = breakdownBy === "Month" ? "MMMM YYYY" : "D MMMM YYYY";

  return (
    <div className={styles.byBarcode}>
      <span className={styles.byBarcode_title}>
        {moment(point.date).format(titleFormat)}
      </span>
      <div className={styles.byBarcode_tableContainer}>
        <table className={styles.byBarcode_table}>
          <thead>
            <tr>
              <th>{t("Color")}</th>
              <th>{t("Size")}</th>
              {LIFETIME_SERIES.map((series) => (
                <th key={series.key}>{t(series.label)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {point.byBarcode.map((row) => (
              <tr key={row.barcodeId}>
                <td>{row.color ?? "—"}</td>
                <td>{row.size ?? "—"}</td>
                {LIFETIME_SERIES.map((series) => (
                  <td key={series.key}>{row[series.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductStatsByBarcodeTable;
